import { render, staticRenderFns } from "./DeleteAccountModal.vue?vue&type=template&id=2c428d82&"
import script from "./DeleteAccountModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteAccountModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteAccountModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports